export default __webpack_public_path__ + "static/how-to-invest-2e8a96ed77d772f1a09c7e541cd5185b.jpg";